<template>
  <div class="order-butttons-container align-center">
    <v-btn
      flat
      v-if="iscart && orderLinesLength > 0"
      class="send-order"
      @click="$emit('send-order')"
    >
      <div class="d-flex align-end ga-2">
        <v-icon
          size="23"
          color="white"
          icon="mdi-receipt-text-send-outline mdi-flip-h"
        />
        <span>{{ $t("SingleOrder.SendOrder") }}</span>
      </div>
    </v-btn>
    <v-btn
      class="cancel-order-edit"
      v-if="isOnEditOrderMode"
      flat
      @click="$emit('cancel-edit')"
    >
      <div class="d-flex align-center ga-1">
        <v-icon size="24" color="black" icon="mdi-close-circle-outline" />
        <span>{{ $t("SingleOrder.cancelEdit") }}</span>
      </div>
    </v-btn>
    <v-btn
      flat
      v-if="editable && !iscart"
      @click="$emit('update-changes')"
      class="send-order orders"
    >
      <div class="d-flex align-center ga-1">
        <v-icon
          size="24"
          color="white"
          :icon="
            !iscart && !isOnEditOrderMode
              ? 'mdi-file-document-edit-outline'
              : 'mdi-text-box-check-outline'
          "
        />
        <span>{{
          !iscart && !isOnEditOrderMode
            ? $t("SingleOrder.Update")
            : $t("SingleOrder.finishEdit")
        }}</span>
      </div>
    </v-btn>
  </div>
</template>

<script>
export default {
  name: 'OrderButtons',
  props: {
    iscart: Boolean,
    isOnEditOrderMode: Boolean,
    editable: Boolean,
    orderLinesLength: Number,
  },
};
</script>

<style scoped lang="scss">
.order-butttons-container {
  display: flex;
  gap: 20px;
}

.send-order {
  display: inline-flex;
  align-items: center;

  font-size: $mediumTextSize;
  background: $cartMainColor;
  font-weight: 400;
  letter-spacing: 0px;
  text-align: right;
  box-shadow: 0px 4px 4px 0px #00000040;
  border-radius: 15px;
  padding: 25px;
  color: white;
  max-width: max-content;

  border: i {
    margin-right: 10px;
  }
  i:lang(en) {
    padding-right: 10px;
    transform: rotate(180deg);
  }
}
.cancel-order-edit {
  display: inline-flex;
  align-items: center;
  border: 1px solid $borderColor;
  background: $primaryBackgroundColor;

  font-size: $smallTextSize;
  font-weight: 400;
  letter-spacing: 0px;
  text-align: right;
  border-radius: 15px;
  padding: 25px;
  color: black;
  max-width: max-content;

  border: i {
    margin-right: 10px;
  }
  i:lang(en) {
    padding-right: 10px;
    transform: rotate(180deg);
  }
}

@media only screen and (max-width: 601px) {
  .order-butttons-container {
    justify-content: space-around;
  }
  .cancel-order-edit {
    max-width: 100%;
  }
}
</style>